(() => {
  const root = document.documentElement;
  if (!root.classList.contains('pallacio-reference')) return;
  let queued = false;
  const arrange = () => {
    queued = false;
    const mode = root.dataset.pallacioSwatchPosition || 'corner';
    document.querySelectorAll('#main .pallacio-product-card, #main .pallacio-tab-card').forEach(card => {
      if (card.hasAttribute('data-pallacio-home-synced')) return;
      const colors = card.querySelector('.pallacio-product-card__colors, .pallacio-tab-card__colors');
      if (!colors) return;
      const target = mode === 'corner'
        ? card.querySelector('.pallacio-product-card__media, .pallacio-tab-card__media')
        : mode === 'under-price'
          ? card.querySelector('.pallacio-product-card__below-price, .pallacio-tab-card__below-price')
          : card.querySelector('.pallacio-product-card__bottom-row, .pallacio-tab-card__bottom');
      if (target && colors.parentElement !== target) target.append(colors);
    });
  };
  const schedule = () => { if (!queued) { queued = true; requestAnimationFrame(arrange); } };
  const start = () => {
    arrange();
    const main = document.querySelector('#main');
    if (main) new MutationObserver(schedule).observe(main, { childList: true, subtree: true });
    window.addEventListener('resize', schedule);
    document.addEventListener('shopify:section:load', schedule);
    new MutationObserver(schedule).observe(root, { attributes: true, attributeFilter: ['data-pallacio-swatch-position'] });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
